import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {onModal} from '../actions/ModalActions';

@connect(state => ({modals: state.modals}), {onModal}, null, {withRef: true})
export default class ModalContainer extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        hidden: PropTypes.bool,
        modals: PropTypes.object,
        onModal: PropTypes.func,
        children: PropTypes.func,
    };

    openModal = (e) => {
        if (e) {
            e.stopPropagation();
        }
        this.props.onModal(this.props.name, true);
    };

    closeModal = () => {
        this.props.onModal(this.props.name, false);
    };

    render() {
        const {hidden, name, modals, children} = this.props;
        if (hidden) {
            return false;
        }
        const isOpen = modals[name];
        return children(isOpen, this.openModal, this.closeModal);
    }
}



// WEBPACK FOOTER //
// ./src/containers/ModalContainer.js